import { Component, OnInit } from '@angular/core';
import { Message } from './messages.model';
import { MessagesService } from './messages.service';
import { MessageType, MessageTab, ReadOptions } from '../../shared/constants';
import { GeneralService } from '../../shared/services/general.service';
import { DeleteConfirmDialogComponent } from '../../shared/components/delete-confirm-dialog/delete-confirm-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material';
import { cloneDeep } from 'lodash';
import { LangChangeEvent } from '@ngx-translate/core';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {
  loading = true;
  messages: Message[] = [];
  alerts: Message[] = [];
  allMessages: Message[];
  tab: MessageTab = MessageTab.ALL;
  allMessagesSelected = false;
  MessageTab = MessageTab;
  displayedMessages: Message[] = [];

  throttle = 300;
  scrollDistance = 1;
  page = 0;
  items = 10;

  reloading = false;

  dialogRef: MatDialogRef<DeleteConfirmDialogComponent>;

  read_only = false;
  unread_only = false;
  is_search = false;
  read_messages: Message[] = [];
  unread_messages: Message[] = [];
  filtered_messages: Message[] = [];
  filtered_unread_messages: Message[] = [];
  filtered_read_messages: Message[] = [];
  search_term: string = null;

  term: string;
  previouslyOpened: any;
  locale: any;
  constructor(private messagesService: MessagesService,
    private generalService: GeneralService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.loading = true;
    this.locale = this.generalService.translate.getBrowserCultureLang();

    this.generalService.translate.onLangChange
    .subscribe((langChangeEvent: LangChangeEvent) => {
             this.locale = langChangeEvent.lang;
           });
    // // don't forget to unsubscribe!
    // this._translateService.onLangChange
    //     .subscribe((langChangeEvent: LangChangeEvent) => {
    //         this.locale = langChangeEvent.lang;
    //     })

    this.initMessages();
  }

  checkStatus(m: Message): boolean {
    if ( !this.read_only && !this.unread_only ) {
      return true;
    } else {
      if ( this.read_only ) {
        if ( m.getIsRead() ) {
          return true;
        } else {
          return false;
        }
      }
      if ( this.unread_only ) {
        if ( m.getIsRead() ) {
          return false;
        } else {
          return true;
        }
      }
    }
  }

  onlyRead(): void {
    if ( this.read_only ) {
      this.read_only = false;
    } else {
      this.read_only = true;
      this.unread_only = false;
      this.read_messages = [];
      Object.keys(this.messages).forEach(key => {
        if ( this.messages[key]['isRead'] ) {
          this.read_messages.push(this.messages[key]);
        }
      });
    }
    // console.log('TCL: MessagesComponent -> this.is_search', this.is_search);
    if ( this.is_search ) {
      this.search({key: ''});
    }
  }

  onlyUnread(): void {
    if ( this.unread_only ) {
      this.unread_only = false;
    } else {
      this.unread_only = true;
      this.read_only = false;
      this.unread_messages = [];
      Object.keys(this.messages).forEach(key => {
        if ( !this.messages[key]['isRead'] ) {
          this.unread_messages.push(this.messages[key]);
        }
      });
    }
    // console.log('TCL: MessagesComponent -> this.is_search', this.is_search);
    if ( this.is_search ) {
      this.search({key: ''});
    }
  }

  search(e: any): void {
    // console.log('TCL: MessagesComponent -> e.key', e.key);
    // console.log('TCL: MessagesComponent -> this.term', this.term);
    let _search = null;
    if ( this.term === undefined ) {
      _search = e.key;
    } else {
      if (
        e.key !== 'ArrowDown' &&
        e.key !== 'ArrowUp' &&
        e.key !== 'ArrowRight' &&
        e.key !== 'ArrowLeft' &&
        e.key !== 'Meta' &&
        e.key !== 'Shift' &&
        e.key !== 'Backspace' &&
        e.key !== 'Tab' &&
        e.key !== 'Enter'
      ) {
        // console.log('TCL: MessagesComponent -> debug');
        _search = this.term + e.key;
      }
    }
    // _search = _search === 'Enter' && !this.term ? null : _search;
    // console.log('TCL: MessagesComponent -> this.term', this.term);
    // console.log('TCL: MessagesComponent -> _search', _search);
    if ( _search ) {
      // console.log('TCL: MessagesComponent -> search');
      this.search_term = _search;
      this.is_search = true;
      this.filtered_messages = [];
      this.filtered_read_messages = [];
      this.filtered_unread_messages = [];
      /*
      // console.log('TCL: MessagesComponent -> filtered_messages', this.filtered_messages);
      // console.log('TCL: MessagesComponent -> this.messages', this.messages);
      // console.log('TCL: MessagesComponent -> this.read_messages', this.read_messages);
      // console.log('TCL: MessagesComponent -> this.unread_messages', this.unread_messages);
      // console.log('TCL: MessagesComponent -> this.unread_only', this.unread_only);
      // console.log('TCL: MessagesComponent -> this.read_only', this.read_only);
      */
      Object.keys(this.messages).forEach(key => {
        const _title = this.messages[key]['title'].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const _text = this.messages[key]['text'].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        _search = _search.normalize('NFD').toLowerCase().replace(/[\u0300-\u036f]/g, '');
        if (
          _title.indexOf(_search) > -1 ||
          _text.indexOf(_search) > -1
        ) {
          // console.log(this.messages[key].isRead);
          if ( this.read_only ) {
            if ( this.messages[key].isRead ) {
              this.filtered_read_messages.push(this.messages[key]);
            }
          } else if ( this.unread_only ) {
            if ( !this.messages[key].isRead ) {
              this.filtered_unread_messages.push(this.messages[key]);
            }
          } else {
            this.filtered_messages.push(this.messages[key]);
          }
        }
      });
      // // console.log('TCL: MessagesComponent -> filtered_messages', this.filtered_messages);
    } else {
      this.is_search = false;
    }
  }

  initMessages() {
    this.page = 0;
    this.throttle = 300;
    this.scrollDistance = 1;
    this.messages = [];
    this.alerts = [];
    this.allMessages = [];
    this.allMessagesSelected = false;
    this.displayedMessages = [];
    $('#list').scrollTop(0);
    this.getMessages(true);
  }

  private getNextAllMessages(): void {
    const toShowMessages = cloneDeep(this.allMessages.slice(0, this.items));
    this.displayedMessages = this.displayedMessages.concat(toShowMessages);
    toShowMessages.forEach(toDeleteMsg => {
      const idx = this.allMessages.findIndex(m => m.getPkid() === toDeleteMsg.getPkid());
      this.allMessages.splice(idx, 1);
    });
  }

  private getMessages(newGet?: boolean): void {
    this.messagesService.getMessages(newGet === true ? true : false)
      .subscribe(
        messages => {
          messages.forEach(el => {
            this.messages.push(el);
          });
          this.loading = false;

        }
      );
  }

  private sortByDate(m1: Message, m2: Message): number {
    if (m1.getDate() > m2.getDate()) {
      return 1;
    }
    if (m1.getDate() < m2.getDate()) {
      return -1;
    }
    return 0;
  }

  /*
  onChangeTab(tab: MessageTab) {
    this.allMessagesSelected = false;
    this.tab = tab;
    this.page = 0;
    this.getMessages();
    $('#list').scrollTop(0);
  }
  */

  getMessageIcon(m: Message): string {
    switch (m.getType()) {
      case (MessageType.MESSAGE):
        return m.isSelected ? './assets/img/icons/ic-messages-delete.svg' :
          ((m.getIsRead() && !m.firstRead) ?
           './assets/img/icons/ic-messages-read.svg' : './assets/img/icons/ic-messages-new.svg');
      case (MessageType.ALERT):
        return m.isSelected ? './assets/img/icons/ic-messages-alerts-delete.svg' :
          (m.getIsRead() && !m.firstRead ?
            './assets/img/icons/ic-messages-alerts-read.svg' : './assets/img/icons/ic-messages-alerts-new.svg');
    }
  }

  onSelectMsg(message: Message, event) {
    message.isSelected = !message.isSelected;
    this.closeMessages(message);
    event.stopPropagation();
  }

  onSelectAllMsg() {
    this.allMessagesSelected = !this.allMessagesSelected;
    this.messages.forEach(m => m.isSelected = this.allMessagesSelected);
  }

  private closeMessages(message: Message): void {
    this.displayedMessages.filter(m => m.getPkid() !== message.getPkid())
      .forEach(m => {

        m.opened = false;
        m.firstRead = false;

        switch (m.getType()) {
          case (MessageType.MESSAGE):
            const idxMsg: number = this.messages.findIndex(msg => msg.getPkid() === m.getPkid());
            this.messages[idxMsg].opened = false;
            this.messages[idxMsg].firstRead = false;
            break;

          case (MessageType.ALERT):
            const idxAlert: number = this.alerts.findIndex(alert => alert.getPkid() === m.getPkid());
            this.alerts[idxAlert].opened = false;
            this.alerts[idxAlert].firstRead = false;
            break;
        }
      });
  }

  openDialog(): void {
    const nrSelectedMessages = this.getSelectedMessages().length;
    const element = nrSelectedMessages > 1 ? 'MESSAGES' : 'MESSAGE';
    this.dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      data: {
        element: element,
        message: `${nrSelectedMessages} ${this.generalService.translate.instant(element.toLowerCase())}
        ${this.generalService.translate.instant('will be permanently deleted.')}`
      },
      autoFocus: false,
      panelClass: 'deleteGenericPopup'
    });

    const sub = this.dialogRef.componentInstance.action
      .subscribe((toDelete: boolean) => {
        // console.log(toDelete);
        if (toDelete) {
          this.deleteMessages(this.messages);
        }
      });
  }

  onDeleteSelectedMgs() {
    this.reloading = true;
    this.openDialog();
  }

  getSelectedMessages(): Message[] {
    return this.messages.filter(m => m.isSelected);
  }

  private deleteMessages(messages: Message[]) {
    messages.forEach(m => {
      if (m.isSelected) {
        this.messagesService.deleteMessage(m.getPkid()).subscribe(
          res => {
            switch (m.getType()) {
              case (MessageType.MESSAGE):
                const idxMsg: number = this.messages.findIndex(msg => msg.getPkid() === m.getPkid());
                this.messages.splice(idxMsg, 1);
                break;

              case (MessageType.ALERT):
                const idxAlert: number = this.alerts.findIndex(msg => msg.getPkid() === m.getPkid());
                this.alerts.splice(idxAlert, 1);
                break;
            }
            this.initMessages();
          }
        );
      }
    }
    );
  }

  onOpenMessage(message: Message) {
    if (this.previouslyOpened === undefined) {
      this.previouslyOpened = message;
    } else {
      if (message !== this.previouslyOpened) {
        this.previouslyOpened.opened = !this.previouslyOpened.opened;
        this.previouslyOpened.firstRead = false;
        this.previouslyOpened = message;
      } else {
        this.previouslyOpened = undefined;
      }
    }
    message.opened = !message.opened;

    if (!message.getIsRead()) {
      this.messagesService.setReadMessage(message.getPkid(), true).subscribe(
        res => {
          message.setIsRead(true);
          message.firstRead = true;

          switch (message.getType()) {
            case (MessageType.MESSAGE):

              const idxMsg: number = this.messages.findIndex(msg => msg.getPkid() === message.getPkid());
              this.messages[idxMsg].setIsRead(true);
              this.messages[idxMsg].firstRead = true;
              break;

            case (MessageType.ALERT):
              const idxAlert: number = this.alerts.findIndex(alert => alert.getPkid() === message.getPkid());
              this.alerts[idxAlert].setIsRead(true);
              this.alerts[idxAlert].firstRead = true;
              break;
          }
        }
      );
    }


      switch (message.getType()) {
        case (MessageType.MESSAGE):
          const idxMsg: number = this.messages.findIndex(msg => msg.getPkid() === message.getPkid());
          this.messages[idxMsg].firstRead = false;
          break;

        case (MessageType.ALERT):
          const idxAlert: number = this.alerts.findIndex(alert => alert.getPkid() === message.getPkid());
          this.alerts[idxAlert].firstRead = false;
          break;
      }

    this.closeMessages(message);
  }

  onScrollDown() {
    this.getMessages();
  }

  getMoreOptions(): string[] {
    const options: string[] = [];

    Object.keys(ReadOptions)
    .forEach(o => {
      options.push(`1#${this.generalService.translate.instant(ReadOptions[o])}`);
    });

    return options;
  }

  changeValue(_readOptions: string) {
    switch (_readOptions) {
      case (ReadOptions.MARK_AS_READ):
        this.readMessages(this.messages, true);
        break;
      case (ReadOptions.MARK_AS_UNREAD):
        this.readMessages(this.messages, false);
        break;
    }
  }

  private readMessages(messages: Message[], read: boolean) {
    messages.filter(m => m.isSelected)
      .forEach(m => {
        this.messagesService.setReadMessage(m.getPkid(), read).subscribe(
          res => {
            switch (m.getType()) {
              case (MessageType.MESSAGE):
                const idxMsg: number = this.messages.findIndex(msg => msg.getPkid() === m.getPkid());
                this.messages[idxMsg].setIsRead(read);
                this.messages[idxMsg].isSelected = false;
                this.messages[idxMsg].firstRead = false;
                this.messages[idxMsg].opened = false;
                if (this.messages[idxMsg] === this.previouslyOpened) {
                  this.previouslyOpened = undefined;
                }
                break;

              case (MessageType.ALERT):
                const idxAlert: number = this.alerts.findIndex(msg => msg.getPkid() === m.getPkid());
                this.alerts[idxAlert].setIsRead(read);
                this.alerts[idxAlert].isSelected = false;
                this.alerts[idxAlert].firstRead = false;
                break;
            }
            // this.getMessages();
            this.allMessagesSelected = false;
          }
        );
      }
      );
  }

  showEmpty(): boolean {
    return (this.messages.length === 0 && this.tab === MessageTab.MESSAGES) ||
      (this.alerts.length === 0 && this.tab === MessageTab.ALERTS ||
        (this.messages.length === 0 && this.alerts.length === 0 && this.tab === MessageTab.ALL));
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/messages/messages.component.ts